function initFocusMenu() {
    const nav = document.getElementById('AccessibleNav');
    if (!nav) return;

    const menuItems = Array.from(nav.querySelectorAll('.site-nav--has-dropdown'));
    const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function getParts(item) {
        return {
            control: item.querySelector('.site-nav__top-level-control'),
            button: item.querySelector('[data-site-nav-trigger]'),
            dropdown: item.querySelector('[data-site-nav-dropdown]')
        };
    }

    function closeMenu(item) {
        const { button, dropdown } = getParts(item);
        item.classList.remove('nav-hover');
        if (button) {
            button.setAttribute('aria-expanded', 'false');
        }
        if (dropdown) {
            dropdown.setAttribute('aria-hidden', 'true');
        }
    }

    function closeMenus(exceptItem) {
      menuItems.forEach((item) => {
        if (item !== exceptItem) {
            closeMenu(item);
        }
      });
    }

    function openMenu(item, focusFirstItem = false) {
        const { button, dropdown } = getParts(item);
        closeMenus(item);
        item.classList.add('nav-hover');
        if (button) {
            button.setAttribute('aria-expanded', 'true');
        }
        if (dropdown) {
            dropdown.setAttribute('aria-hidden', 'false');

            if (focusFirstItem) {
                const firstFocusable = dropdown.querySelector(focusableSelector);
                if (firstFocusable) {
                    firstFocusable.focus();
                }
            }
        }
    }

    menuItems.forEach((item) => {
      const { control, button, dropdown } = getParts(item);

      if (!control || !button || !dropdown) return;

      button.addEventListener('click', () => {
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
          closeMenu(item);
        } else {
          openMenu(item);
        }
      });

      item.addEventListener('mouseenter', () => openMenu(item));
      item.addEventListener('mouseleave', () => closeMenu(item));

      control.addEventListener('keydown', (event) => {
        const isArrowDown = event.key === 'ArrowDown';
        const isSpace = event.key === ' ' || event.key === 'Spacebar';
        const isToggleButton = event.target.closest('[data-site-nav-trigger]');

        if (!isArrowDown && !isSpace) return;
        if (isToggleButton && isSpace) return;

        event.preventDefault();
        openMenu(item, isArrowDown);
      });

      item.addEventListener('focusout', (event) => {
        if (item.matches(':hover')) return;

        if (!item.contains(event.relatedTarget)) {
          closeMenu(item);
        }
      });

      item.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;

        closeMenu(item);
        button.focus();
      });

      // Sync initial ARIA state if the item is already hovered when listeners are attached.
      if (item.matches(':hover')) openMenu(item);
    });
}

initFocusMenu();